export const ACCESS_CODES = {
  K5: 'k5SelDigital',
  MSP: 'mspDigital',
  HS: 'highSchool',
}

export const PREFERENCE_NAMES = {
  BPU_ENABLED: 'bpu_enabled',
  CPU_ENABLED: 'cpu_enabled',
  DWBP_ENABLED: 'dwbp_enabled',
  EFP_ENABLED: 'efp_enabled',
  HSP_ENABLED: 'hsp_enabled',
  K5P_ENABLED: 'k5p_enabled',
  MSP_ENABLED: 'msp_enabled',
  SELA_ENABLED: 'sela_enabled',
}

export const isPreferenceValueSet = value =>
  value !== null && value !== undefined

export const isNonEmptyString = value =>
  isPreferenceValueSet(value) && String(value).trim().length > 0

export const isProgramEnabledSet = value =>
  value !== null && value !== undefined

export const isPairedGoalComplete = ({ date, value, textField = false }) => {
  const valueIsSet = textField
    ? isNonEmptyString(value)
    : isPreferenceValueSet(value)

  return isPreferenceValueSet(date) && valueIsSet
}

const preferenceNameToKey = name => {
  if (!name) return name

  const camelCaseName = name.replace(/_([a-zA-Z0-9])/g, (_, character) =>
    character.toUpperCase(),
  )
  return camelCaseName.charAt(0).toLowerCase() + camelCaseName.slice(1)
}

const coerceBooleanValue = value => {
  if (typeof value === 'boolean') {
    return value
  }

  if (value === null || value === undefined) {
    return null
  }

  return value === 'true' || value === true || value === 1
}

export const getProgramPreferencesFromArray = (
  preferences,
  { accessCode, assignmentType = 'Site' } = {},
) => {
  if (!Array.isArray(preferences) || !accessCode) {
    return {}
  }

  return preferences
    .filter(
      pref =>
        pref?.assignmentType === assignmentType &&
        pref?.accessCode === accessCode,
    )
    .reduce((accumulator, pref) => {
      if (!pref?.name) {
        return accumulator
      }

      const key = preferenceNameToKey(pref.name)
      let value = pref.value

      if (pref.valueType === 'Boolean') {
        value = coerceBooleanValue(value)
      }

      accumulator[key] = value
      return accumulator
    }, {})
}

export const getK5DigitalFromPreferences = preferences =>
  getProgramPreferencesFromArray(preferences, {
    accessCode: ACCESS_CODES.K5,
  })

export const getMspDigitalFromPreferences = preferences =>
  getProgramPreferencesFromArray(preferences, {
    accessCode: ACCESS_CODES.MSP,
  })

export const getHighSchoolFromPreferences = preferences =>
  getProgramPreferencesFromArray(preferences, {
    accessCode: ACCESS_CODES.HS,
  })

export const getUserProgramPreferencesFromArray = (
  preferences,
  { accessCode } = {},
) =>
  getProgramPreferencesFromArray(preferences, {
    accessCode,
    assignmentType: 'SiteUser',
  })

export const getPreferenceValue = (
  preferences,
  { name, accessCode, programCode, assignmentType = 'Site' } = {},
) => {
  if (!Array.isArray(preferences) || !name) {
    return undefined
  }

  const match = preferences.find(pref => {
    if (pref?.name !== name) {
      return false
    }

    if (accessCode && pref?.accessCode !== accessCode) {
      return false
    }

    if (programCode && pref?.programCode !== programCode) {
      return false
    }

    if (assignmentType && pref?.assignmentType !== assignmentType) {
      return false
    }

    return true
  })

  if (!match) {
    return undefined
  }

  if (match.valueType === 'Boolean') {
    return coerceBooleanValue(match.value)
  }

  return match.value
}

export const isCustomGoalComplete = ({ date, text }) =>
  isPairedGoalComplete({ date, value: text, textField: true })
